export var HttpClientParseMode;
(function (HttpClientParseMode) {
    /**Content is interpreted as a UTF8 character string*/
    HttpClientParseMode["STRING"] = "STRING";
    /**Content is parsed as UTF8 JSON*/
    HttpClientParseMode["OBJECT"] = "OBJECT";
    /**Content is not interpreted, but available as a raw array of bytes*/
    HttpClientParseMode["BYTES"] = "BYTES";
})(HttpClientParseMode || (HttpClientParseMode = {}));
//# sourceMappingURL=HttpclientTypes.js.map